import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M-5,-1h0.5v1h-0.5zM-3.5,-1h0.5v0.5h-0.5zM3,-1h0.5v0.5h-0.5zM4.5,-1h0.5v1h-0.5zM-3.5,-0.5h1v0.5h-1zM2.5,-0.5h1v0.5h-1zM-5,0h2.5v0.5h-2.5zM2.5,0h2.5v0.5h-2.5zM-4.5,0.5h1.5v0.5h-1.5zM3,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'roofA',
      d: 'M-6,-8.5h1.5v0.5h-1.5zM4.5,-8.5h1.5v0.5h-1.5zM-6,-8h12v1h-12zM-3.5,-7h0.5v0.5h-0.5zM3.5,-7h1v0.5h-1zM-5,-6.5h4v0.5h-4zM1,-6.5h2v0.5h-2zM3.5,-6.5h1.5v0.5h-1.5zM-5,-6h10v0.5h-10zM-5,-5.5h8v0.5h-8zM3.5,-5.5h1.5v0.5h-1.5zM-3.5,-5h0.5v0.5h-0.5zM3.5,-5h1v2.5h-1zM-4,-4.5h1v3.5h-1zM4,-2.5h0.5v2.5h-0.5zM-4,-1h0.5v1h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M-4.5,-7h1v0.5h-1zM3,-7h0.5v1h-0.5zM3,-5.5h0.5v3h-0.5zM-4.5,-5h1v0.5h-1zM-4.5,-4.5h0.5v4.5h-0.5zM3,-2.5h1v1.5h-1zM3.5,-1h0.5v1h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-6.5,-9.5h0.5v0.5h-0.5zM-6.5,-9h5.5v0.5h-5.5zM1,-9h5.5v0.5h-5.5zM-4.5,-8.5h9v0.5h-9z',
    },
    { paint: 'wheat', d: 'M-3,-5h2.5v0.5h-2.5zM0.5,-5h2.5v0.5h-2.5zM-1.5,-4.5h3.5v0.5h-3.5z' },
    {
      paint: 'sail',
      d: 'M-2.5,-4.5h1v0.5h-1zM-2,-4h1v0.5h-1zM0.5,-4h1v0.5h-1zM-2,-3.5h0.5v0.5h-0.5zM1,-3.5h0.5v1h-0.5z',
    },
    { paint: 'epicGold', d: 'M-1,-7h2v1h-2z' },
  ],
  pixels: 273,
};
export const sprites: readonly PixelSprite[] = [variant0];
